/* Mon Livre de Vie v8 — bounded layout work and on-demand help. */
(function () {
  'use strict';
  if (window.MLVPageUI) return;
  var instances = new Map();
  function mount(section) {
    if (instances.has(section)) return;
    var sticky = section.querySelector('#mlvSticky');
    var hero = section.querySelector('#hero');
    if (!hero) return;
    var price = section.querySelector('#prix');
    var finalButton = section.querySelector('#finalCTABtn');
    var finalSection = finalButton ? finalButton.closest('section') : section.querySelector('.sec-final');
    var footer = document.querySelector('.mhf-footer, footer, .footer, #shopify-section-footer');
    var compact = window.matchMedia('(max-width:768px)');
    var raf = 0, lastVisible = null, lastHelpHidden = null, disposed = false;
    var observers = [], cleanups = [];
    function listen(target, event, callback, options) {
      target.addEventListener(event, callback, options);
      cleanups.push(function () {target.removeEventListener(event, callback, options);});
    }
    function intersects(el, margin) {
      if (!el) return false;
      var r = el.getBoundingClientRect();
      return r.width > 0 && r.height > 0 && r.top < window.innerHeight - margin && r.bottom > 0;
    }
    function modalOpen() {
      // Configurator is injected lazily; re-query rather than keeping a stale reference.
      return ['ck','urgenteModal'].some(function (id) {
        var el = document.getElementById(id);
        if (!el) return false;
        var css = window.getComputedStyle(el);
        return !el.hidden && css.display !== 'none' && css.visibility !== 'hidden';
      });
    }
    function update() {
      raf = 0;
      if (disposed) return;
      // All layout reads precede the writes below.
      var bounds = hero.getBoundingClientRect();
      var blocked = modalOpen();
      var show = compact.matches && bounds.bottom <= 24 && !blocked &&
        !intersects(price,72) && !intersects(finalSection,72) && !intersects(footer,100);
      var help = document.getElementById('mhCW');
      var helpOpen = !!help && help.querySelector('[aria-expanded="true"]');
      var hideHelp = blocked || (compact.matches && bounds.bottom > window.innerHeight * 0.3 && bounds.top < window.innerHeight && !helpOpen);
      if (sticky && show !== lastVisible) {
        // The same state controls visibility and keyboard/screen-reader availability.
        sticky.inert = !show;
        sticky.classList.toggle('on',show);
        sticky.setAttribute('aria-hidden',show ? 'false' : 'true');
        document.body.classList.toggle('mlv-sticky-visible',show);
        lastVisible = show;
      }
      if (help && (hideHelp !== lastHelpHidden || help.dataset.mlvHidden !== String(hideHelp))) {
        help.classList.toggle('mhcw-hidden',hideHelp);
        help.inert = hideHelp;
        help.dataset.mlvHidden = String(hideHelp);
        lastHelpHidden = hideHelp;
      }
    }
    function schedule() { if (!raf && !disposed) raf = requestAnimationFrame(update); }
    listen(window,'scroll',schedule,{passive:true});
    listen(window,'resize',schedule,{passive:true});
    listen(window,'orientationchange',schedule,{passive:true});
    // The lazily loaded configurator also owns an Escape listener. After all
    // listeners run, the menu toggle must retain focus when the menu closes.
    listen(document,'keydown',function (event) {
      var menu = document.getElementById('navMobile');
      if(event.key === 'Escape' && menu && menu.classList.contains('open')) {
        requestAnimationFrame(function () {
          var button = document.getElementById('navBurger');
          if(button && !modalOpen())button.focus({preventScroll:true});
        });
      }
    },true);
    listen(window,'mlv:promotion-change',schedule);
    listen(document,'mlv:assistant-ready',schedule);
    // Observe only state-bearing nodes, never the whole DOM at every mutation.
    function observeModal(el) {
      if (!el || el.dataset.mlvUiObserved) return;
      el.dataset.mlvUiObserved = 'true';
      var observer = new MutationObserver(schedule);
      observer.observe(el,{attributes:true,attributeFilter:['class','style','hidden','aria-hidden']});
      observers.push(observer);
    }
    if ('MutationObserver' in window) {
      var root = document.getElementById('mlv-configurator-root');
      if (root) {
        var observer = new MutationObserver(function () {observeModal(document.getElementById('ck'));schedule();});
        observer.observe(root,{childList:true,subtree:true}); observers.push(observer);
      }
      observeModal(document.getElementById('ck'));
      observeModal(document.getElementById('urgenteModal'));
    }
    if ('ResizeObserver' in window) {
      var sizeObserver = new ResizeObserver(schedule);
      [hero,price,footer].forEach(function (el) {if(el)sizeObserver.observe(el);});
      observers.push(sizeObserver);
    }
    var placeholder = section.querySelector('[data-mlv-assistant-placeholder]');
    if (placeholder) {
      var button = placeholder.querySelector('button');
      var message = placeholder.querySelector('[data-mlv-assistant-status]');
      var pending = false;
      listen(button,'click',function () {
        if (pending) return;
        if (window.MLVAssistant) {window.MLVAssistant.open();return;}
        pending = true;
        button.disabled = true;button.setAttribute('aria-busy','true');
        message.hidden = false;message.textContent = 'Ouverture de l’assistant…';
        var script = document.createElement('script');
        script.src = placeholder.dataset.mlvAssistantSrc;
        var timeout;
        function fail() {
          clearTimeout(timeout); script.remove(); pending = false;
          button.disabled = false;button.removeAttribute('aria-busy');
          message.replaceChildren(document.createTextNode('Impossible de charger l’assistant. Réessayez ou '));
          var link = document.createElement('a');link.href='/pages/contact';link.textContent='contactez notre équipe';message.appendChild(link);
          message.hidden = false;
        }
        script.onerror = fail;
        script.onload = function () {
          clearTimeout(timeout);pending=false;
          if (window.MLVAssistant) {window.MLVAssistant.open();schedule();}
          else fail();
        };
        timeout = setTimeout(fail,15000);
        document.head.appendChild(script);
      });
    }
    update();
    instances.set(section,function () {
      disposed=true;cleanups.forEach(function (f) {f();});observers.forEach(function (o) {o.disconnect();});
      if(raf)cancelAnimationFrame(raf);
      document.body.classList.remove('mlv-sticky-visible');instances.delete(section);
    });
  }
  function init() {
    document.querySelectorAll('#hero').forEach(function (hero) {mount(hero.closest('.shopify-section') || document.body);});
  }
  window.MLVPageUI = {init:init};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('shopify:section:unload',function (e) {
    instances.forEach(function (destroy, section) {if(e.target===section || e.target.contains(section))destroy();});
  });
}());
